export const ADMIN_OTP = 'admin.otp';
